import { render, staticRenderFns } from "./MultiLanguageTabs.html?vue&type=template&id=2c6fc850&external"
import script from "./MultiLanguageTabs.ts?vue&type=script&lang=ts&external"
export * from "./MultiLanguageTabs.ts?vue&type=script&lang=ts&external"
import style0 from "./MultiLanguageTabs.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports